module.exports = __webpack_public_path__ + "img/adminBoard.71630d92.png";